import React from 'react'
import { H2, Row, Skeleton } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { type PersonType } from '../../../merge-common/types/general'
import { personTypeMap } from '../../../merge-common/helpers'
import ColumnHeadingPadding from '../../../merge-common/layout/ColumnHeadingPadding'

type Props = {
  personType: PersonType
}

/**
 * The merge column heading (e.g. "Duplicate Person", "Main Person") shown while the page loads.
 * Mirrors PersonColumnHeading: the heading text alongside a placeholder for the info icon button.
 */
export default function PersonColumnHeadingSkeleton({ personType }: Props): JSX.Element {
  const [t] = useTranslation()

  return (
    <ColumnHeadingPadding personType={personType}>
      <Row gutters="nano" alignItemsY="middle">
        <H2 size="H6">{t(personTypeMap[personType].newHeadingKey)}</H2>
        {/* eslint-disable-next-line test-selectors/button -- NA */}
        <Skeleton.IconButton size="xs" />
      </Row>
    </ColumnHeadingPadding>
  )
}
